import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../_metronic/layout";
import { DashboardPage } from "./DashboardPage";
import  TokenPage  from "./auth/TokenPage";

// );

export default function BasePage() {

    return (
        // <Suspense fallback={<LayoutSplashScreen/>}>
        <Switch>
            {
                /* Redirect from root URL to /dashboard. */
               <Redirect exact from="/" to="/dashboard" /> //,
               // <Redirect exact from="/token" to="/token" />
            }

            <ContentRoute path="/dashboard" component={DashboardPage} />
            <ContentRoute path="/token" component={TokenPage} />

        </Switch>
        // </Suspense>
    );
}
